var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('XLMTxContainer',{attrs:{"tx":_vm.tx}},[_c('div',{staticClass:"manage_data"},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.name)+": ")]),(_vm.deleted)?_c('span',[_vm._v(" Deleted ")]):_c('span',[_vm._v(" "+_vm._s(_vm.value_string)+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }